import { CompanyTypeRequestFormat } from "@/shared/types";

export const shippingInfosUrl = {
  // 목록 조회는 company_type과 무관하게 /buyers/{buyer_id} 고정이지만,
  // 생성은 company_type이 경로에 들어간다 (스펙 그대로).
  byBuyer: (buyerId: number) => `/buyers/${buyerId}/shipping-infos`,
  byCompany: (companyType: CompanyTypeRequestFormat, companyId: number) =>
    `/${companyType}/${companyId}/shipping-infos`,
};
